import App from 'app/app.js';

function LtCheckoutProgressIndicatorDirective() {
  return {
    restrict: 'E',
    scope: {
      current: '@ltCurrent',
      total: '@ltTotal'
    },
    template:
      '<div class="row">' +
      '<div class="col-xs-12">' +
      '<ul class="progress-indicator">' +
      '<li ng-repeat="step in steps" class="step{{step}}" ng-class="{active: step <= current}"><span ng-bind="step"></span></li>' +
      '</ul>' +
      '</div>' +
      '</div>',
    link: function (scope) {
      scope.total = parseInt(scope.total || '3', 10);
      scope.current = parseInt(scope.current || '1', 10);
      scope.steps = R.range(1, scope.total + 1);
    }
  };
}

App.directive('ltCheckoutProgressIndicator', LtCheckoutProgressIndicatorDirective);
